module.exports = __webpack_public_path__ + "newsdefault5.jpg?c9b139e5cee994c8819c449500cb0c17";